import { createSelector } from 'reselect';

import { FetchStatus } from '@neptune/shared/common-domain';
import { naturalStringComparator } from '@neptune/shared/common-util';

import { Dashboard } from 'domain/dashboard';
import { AppState } from 'state/types';

import getState from '../selectors';

import { DashboardsState } from './types';

function getProjectDashboardsRaw(state: AppState): DashboardsState {
  return getState(state).projectDashboards;
}

export const getProjectDashboardFetchStatus = (state: AppState): FetchStatus =>
  getProjectDashboardsRaw(state).fetchStatus;

export const getProjectDashboards = createSelector([getProjectDashboardsRaw], (dashboardsState) => {
  const dashboards = dashboardsState.dashboards.sort((a, b) =>
    naturalStringComparator(a.name, b.name),
  );

  return {
    ...dashboardsState,
    dashboards,
  };
});

export const getDashboards = (state: AppState) => getProjectDashboards(state).dashboards;

export const getDashboard = createSelector(
  [getDashboards, (state: AppState, branchId: string) => branchId],
  (compareDashboards, branchId) => {
    return compareDashboards.find(({ versionBranchId }) => versionBranchId === branchId);
  },
);

export const getDefaultDashboard = (state: AppState): Dashboard | null =>
  getDashboards(state)[0] ?? null;
